































import {Component, Prop} from "vue-property-decorator";
import Vue from "vue";
import orderApi from "@/api/orderApi";
import {DATE_SLASH_FORMAT, HTTP_STATUS_OK} from "@/common/constant";
import commonApi from "@/api/commonApi";
import moment from "moment";

@Component({
  name: "OrderThanks",
})
export default class OrderComplete extends Vue {
  @Prop({
    default: null,
  })
  orderId;
  salsDay:string = null;
  desireDlvrDay:string = null;
  showAttention = false;
  deliveryConfig = {
    order_deadline_hour: '10',
    order_deadline_minute: '00',
  };

  get deadLineTIme() {
    return this.deliveryConfig.order_deadline_hour + ':' + String(this.deliveryConfig.order_deadline_minute).padStart(2, '0')
  }

  mounted() {
    if (this.orderId) {
      this.loadOrder();
      this.loadDeliverySetting();
    }
  }

  async loadOrder() {
    const result = await orderApi.thanks(this.orderId);
    if (result.status === HTTP_STATUS_OK) {
      this.salsDay = moment(result.data.data.sals_day).format(DATE_SLASH_FORMAT);
      this.desireDlvrDay = moment(result.data.data.desire_dlvr_day).format(DATE_SLASH_FORMAT);
      this.showAttention = result.data.data.showAttention;
    }
  }

  public async loadDeliverySetting(parameters = {}) {
    this.deliveryConfig = await commonApi.setting(parameters);
  }
}
